// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/image-upload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/image-upload-error.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  gap: 32px;
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
  /* display: flex */
}
.modal-content-image{
  /* margin-top: -18px; */
}
.upload-section {
  /* cursor: pointer; */
}

.form-section {
  flex: 1 1;
  min-width: 0;
  margin-left: 24px;
  margin-top: -5px;
}

.ant-form-item {
  margin-bottom: 16px;
}

.ant-form-item-label > label {
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}
.image-upload-section{
  display: flex;

}
.ant-select-selector, .ant-input, .ant-input-textarea {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}


.ant-tag {
  margin: 0 8px 8px 0;
  padding: 4px 10px;
}

.upload-area{
  width: 320px;
  height: 320px;
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s;
  background-color: #fafafa;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-area-error {
  width: 320px;
  height: 320px;
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.upload-icon {
  width: 52px;
  height: 72px;
  margin-bottom: 9px;
}
.upload-tips{
  color: var(--black, #000);
text-align: center;
font-family: "SegoeUI-SemiBold" !important;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: normal;
}
.upload-link {
  color: #6c5ce7;
  color: var(--Purple_mai, var(--Purplev_main, #5F09E0));
font-family: "SegoeUI-SemiBold" !important;
font-size: 16px;
font-weight: 600;
line-height: normal;
text-decoration-line: underline;
text-decoration-style: solid;
text-decoration-skip-ink: none;
text-decoration-thickness: auto;
text-underline-offset: auto;
text-underline-position: from-font;
}

.upload-support {
  font-size: 14px;
  margin-top: 16px;
  color: var(--Gry_707070, #707070);
text-align: center;
font-family: "Segoe UI";
font-style: normal;
font-weight: 400;
line-height: normal;
}
.upload-support-max{
  font-size: 14px;
  color: var(--Gry_707070, #707070);
text-align: center;
font-family: "Segoe UI";
font-style: normal;
font-weight: 400;
line-height: normal;
}

.progress-container {
  height: 6px;
  background-color: #f5f5f5;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 16px;
}

.progress-bar {
  height: 100%;
  background-color: #00b42a;
  transition: width 0.3s;
}

.progress-text {
  position: absolute;
  right: 16px;
  top: -20px;
  color: #00b42a;
  font-size: 12px;
}

.file-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 16px;
}

.preview-image {
  max-width: 100%;
  max-height: 240px;
  object-fit: contain;
  border-radius: 4px;
  margin-bottom: 12px;
}

.file-name {
  font-size: 14px;
  color: #303133;
  text-align: center;
  word-break: break-all;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-preview-full {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-image-full {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.file-name-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 0px 10px;
  font-size: 14px;
  text-align: left;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  color: var(--White-6F, #FFF);
  height: 40px;
  line-height: 40px;
font-family: "Segoe UI";
}

.image-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 10;
}

.image-loading-gif {
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
}

.image-loading-text {
  color: #666;
  font-size: 14px;
  font-family: "Segoe UI";
  margin: 0;
}

.file-upload-error {
  color: #CC3939;
  font-size: 12px;
  margin-top: 4px;
  text-align: left;
}

.issue-type-selector {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-item-half {
  flex: 1 1;
}

.upload-modal .modal-footer {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  gap: 16px;
}

.cancel-btn {
  background-color: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.save-close-btn {
  background-color: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.save-next-btn {
  background-color: #6c5ce7;
  border-color: #6c5ce7;
  color: white;
}

.cancel-btn, .save-close-btn, .save-next-btn {
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
}

.ant-tag {
  background-color: #f0f2f5;
  border-color: #e5e6eb;
}

.modal-content-image .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-radius: 4px !important;
}

.ant-form-item-label > label {
  font-weight: 500;
}
.upload-modal-image .ant-select-single .ant-select-selector  {
  border-radius: 4px !important; 
}
.upload-modal-image .ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
  border-color: #CC3939 !important;
  box-shadow: none !important;
  border-radius: 4px !important; 
}
.upload-modal-image button{
  border-radius: 17px;
padding-left: 24px !important;
padding-right: 24px !important;
}
.upload-modal-image .modal-footer{
  height: 130px;
}
.upload-modal-image .modal-footer .ant-space-gap-col-small{
  gap: 24px;
}

.add-btn-disable-image.ant-btn-color-purple.ant-btn-variant-solid{
  background-color:#EFE6FC !important;
  color: #FFF8F8 !important;
  border-color:#fff
}
.add-btn-disable-image{
background: #EFE6FC !important;
background-color: #EFE6FC !important;
color: #FFF8F8 !important;
text-align: center;
font-family: SegoeUI-SemiBold;
font-size: 14px;
font-style: normal;
line-height: normal;
border-radius: 16px;
/* margin-left: 24px; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/resource/image-base/components/addImageModal.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;;AAEf;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,yDAA4D;EAC5D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yDAAkE;AACpE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B,kBAAkB;AAClB,0CAA0C;AAC1C,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;EACE,cAAc;EACd,sDAAsD;AACxD,0CAA0C;AAC1C,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,+BAA+B;AAC/B,4BAA4B;AAC5B,8BAA8B;AAC9B,+BAA+B;AAC/B,2BAA2B;AAC3B,kCAAkC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC,kBAAkB;AAClB,uBAAuB;AACvB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;EACE,eAAe;EACf,iCAAiC;AACnC,kBAAkB;AAClB,uBAAuB;AACvB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;AACnB,uBAAuB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB,6BAA6B;AAC7B,8BAA8B;AAC9B;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB;AACF;AACA;AACA,8BAA8B;AAC9B,oCAAoC;AACpC,yBAAyB;AACzB,kBAAkB;AAClB,6BAA6B;AAC7B,eAAe;AACf,kBAAkB;AAClB,mBAAmB;AACnB,mBAAmB;AACnB,uBAAuB;AACvB","sourcesContent":[".modal-content {\n  gap: 32px;\n  padding: 24px;\n  background-color: #fff;\n  border-radius: 8px;\n  /* display: flex */\n}\n.modal-content-image{\n  /* margin-top: -18px; */\n}\n.upload-section {\n  /* cursor: pointer; */\n}\n\n.form-section {\n  flex: 1;\n  min-width: 0;\n  margin-left: 24px;\n  margin-top: -5px;\n}\n\n.ant-form-item {\n  margin-bottom: 16px;\n}\n\n.ant-form-item-label > label {\n  font-weight: 500;\n  color: #303133;\n  font-size: 14px;\n}\n.image-upload-section{\n  display: flex;\n\n}\n.ant-select-selector, .ant-input, .ant-input-textarea {\n  border-radius: 4px;\n  border: 1px solid #dcdfe6;\n}\n\n\n.ant-tag {\n  margin: 0 8px 8px 0;\n  padding: 4px 10px;\n}\n\n.upload-area{\n  width: 320px;\n  height: 320px;\n  border-radius: 8px;\n  text-align: center;\n  transition: all 0.3s;\n  background-color: #fafafa;\n  background-image: url('/src/assets/images/image-upload.svg');\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.upload-area-error {\n  width: 320px;\n  height: 320px;\n  border-radius: 8px;\n  text-align: center;\n  transition: all 0.3s;\n  background-color: #fafafa;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-image: url('/src/assets/images/image-upload-error.svg');\n}\n\n.upload-icon {\n  width: 52px;\n  height: 72px;\n  margin-bottom: 9px;\n}\n.upload-tips{\n  color: var(--black, #000);\ntext-align: center;\nfont-family: \"SegoeUI-SemiBold\" !important;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.upload-link {\n  color: #6c5ce7;\n  color: var(--Purple_mai, var(--Purplev_main, #5F09E0));\nfont-family: \"SegoeUI-SemiBold\" !important;\nfont-size: 16px;\nfont-weight: 600;\nline-height: normal;\ntext-decoration-line: underline;\ntext-decoration-style: solid;\ntext-decoration-skip-ink: none;\ntext-decoration-thickness: auto;\ntext-underline-offset: auto;\ntext-underline-position: from-font;\n}\n\n.upload-support {\n  font-size: 14px;\n  margin-top: 16px;\n  color: var(--Gry_707070, #707070);\ntext-align: center;\nfont-family: \"Segoe UI\";\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n.upload-support-max{\n  font-size: 14px;\n  color: var(--Gry_707070, #707070);\ntext-align: center;\nfont-family: \"Segoe UI\";\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n\n.progress-container {\n  height: 6px;\n  background-color: #f5f5f5;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.progress-bar {\n  height: 100%;\n  background-color: #00b42a;\n  transition: width 0.3s;\n}\n\n.progress-text {\n  position: absolute;\n  right: 16px;\n  top: -20px;\n  color: #00b42a;\n  font-size: 12px;\n}\n\n.file-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 16px;\n}\n\n.preview-image {\n  max-width: 100%;\n  max-height: 240px;\n  object-fit: contain;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n.file-name {\n  font-size: 14px;\n  color: #303133;\n  text-align: center;\n  word-break: break-all;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-preview-full {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.preview-image-full {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.file-name-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 14px;\n  text-align: left;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  color: var(--White-6F, #FFF);\n  height: 40px;\n  line-height: 40px;\nfont-family: \"Segoe UI\";\n}\n\n.image-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  z-index: 10;\n}\n\n.image-loading-gif {\n  width: 48px;\n  height: 48px;\n  margin-bottom: 12px;\n}\n\n.image-loading-text {\n  color: #666;\n  font-size: 14px;\n  font-family: \"Segoe UI\";\n  margin: 0;\n}\n\n.file-upload-error {\n  color: #CC3939;\n  font-size: 12px;\n  margin-top: 4px;\n  text-align: left;\n}\n\n.issue-type-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.selected-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.form-item-half {\n  flex: 1;\n}\n\n.upload-modal .modal-footer {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n  gap: 16px;\n}\n\n.cancel-btn {\n  background-color: #fff;\n  color: #606266;\n  border: 1px solid #dcdfe6;\n}\n\n.save-close-btn {\n  background-color: #fff;\n  color: #606266;\n  border: 1px solid #dcdfe6;\n}\n\n.save-next-btn {\n  background-color: #6c5ce7;\n  border-color: #6c5ce7;\n  color: white;\n}\n\n.cancel-btn, .save-close-btn, .save-next-btn {\n  padding: 8px 20px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.ant-tag {\n  background-color: #f0f2f5;\n  border-color: #e5e6eb;\n}\n\n.modal-content-image .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  border-radius: 4px !important;\n}\n\n.ant-form-item-label > label {\n  font-weight: 500;\n}\n.upload-modal-image .ant-select-single .ant-select-selector  {\n  border-radius: 4px !important; \n}\n.upload-modal-image .ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {\n  border-color: #CC3939 !important;\n  box-shadow: none !important;\n  border-radius: 4px !important; \n}\n.upload-modal-image button{\n  border-radius: 17px;\npadding-left: 24px !important;\npadding-right: 24px !important;\n}\n.upload-modal-image .modal-footer{\n  height: 130px;\n}\n.upload-modal-image .modal-footer .ant-space-gap-col-small{\n  gap: 24px;\n}\n\n.add-btn-disable-image.ant-btn-color-purple.ant-btn-variant-solid{\n  background-color:#EFE6FC !important;\n  color: #FFF8F8 !important;\n  border-color:#fff\n}\n.add-btn-disable-image{\nbackground: #EFE6FC !important;\nbackground-color: #EFE6FC !important;\ncolor: #FFF8F8 !important;\ntext-align: center;\nfont-family: SegoeUI-SemiBold;\nfont-size: 14px;\nfont-style: normal;\nline-height: normal;\nborder-radius: 16px;\n/* margin-left: 24px; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
